module.exports = __webpack_public_path__ + "img/location.218326d0.svg";